import { call, put, takeEvery } from 'redux-saga/effects';
import * as types from './licensePrivilegesPowerSyncActionType';
import * as actions from './licensePrivilegesPowerSyncActions';
import * as services from './licensePrivilegesPowerSyncServices';
import { downloadBase64File } from '../../../../utils/fileDownloads';
import SweetAlert from '../../../../components/sweetalert/SweetAlert.js';

//------------------ License & Privileges Power Sync - start------------------//
function* fetchLicensePrivilegesPowerSyncSaga(action) {
    try {
        const response = yield call(services.getLicensePrivilegesPowerSync, action.payload);
        if (!response) {
            throw new Error('No response received from API');
        }
        yield put(actions.fetchLicensePrivilegesPowerSyncSuccess(response?.values));
    } catch (error) {
        const errorMessage = 'Failed to fetch License & Privileges Power Sync data.';
        console.error('License Privileges Power Sync API Error:', error);
        SweetAlert.error({ title: 'Error!', text: errorMessage });
        yield put(actions.fetchLicensePrivilegesPowerSyncFailure(errorMessage));
    }
}

function* fetchLicensePrivilegesPowerSyncFilterOptionsSaga() {
    try {
        const response = yield call(services.getLicensePrivilegesPowerSyncFilterOptions);
        if (response?.success) {
            yield put(actions.fetchLicensePrivilegesPowerSyncFilterOptionsSuccess(response?.values));
        } else {
            yield put(actions.fetchLicensePrivilegesPowerSyncFilterOptionsFailure('No filter options found'));
        }
    } catch (error) {
        console.error('License Privileges Power Sync Filter Options Error:', error);
        yield put(actions.fetchLicensePrivilegesPowerSyncFilterOptionsFailure('Failed to fetch filter options'));
    }
}

function* exportLicensePrivilegesPowerSyncSaga(action) {
    try {
        const { exportAPIURL, payload, moduleName, fileName } = action.payload;
        const response = yield call(services.exportLicensePrivilegesPowerSync, exportAPIURL, payload);
        const base64Data = response?.values || response;
        yield call(downloadBase64File, base64Data, moduleName, fileName);
        SweetAlert.success({ title: 'Success!', text: 'License & Privileges Power Sync report exported successfully.' });
        yield put(actions.exportLicensePrivilegesPowerSyncSuccess(response));
    } catch (error) {
        console.error('Export error:', error);
        SweetAlert.error({ title: 'Error!', text: 'License & Privileges Power Sync export failed. Please try again.' });
        yield put(actions.exportLicensePrivilegesPowerSyncFailure('Export failed'));
    }
}
//------------------ License & Privileges Power Sync - end------------------//

export default function* licensePrivilegesPowerSyncSaga() {
    // License & Privileges Power Sync - start
    yield takeEvery(types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_REQUEST, fetchLicensePrivilegesPowerSyncSaga);
    yield takeEvery(types.FETCH_LICENSE_PRIVILEGES_POWER_SYNC_FILTER_OPTIONS_REQUEST, fetchLicensePrivilegesPowerSyncFilterOptionsSaga);
    yield takeEvery(types.EXPORT_LICENSE_PRIVILEGES_POWER_SYNC_REQUEST, exportLicensePrivilegesPowerSyncSaga);
    // License & Privileges Power Sync - end
}
